import { useEffect } from 'react'

/**
 * Favicon SVG embutido para popups de ferramentas (aba/janela no Chrome).
 * O ícone do app Chrome em si não é controlável por páginas web.
 */
export const ROUTER_MANAGEMENT_FAVICON_HREF =
  'data:image/svg+xml,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect width="32" height="32" rx="6" fill="#5b21b6"/><rect x="5" y="7" width="22" height="15" rx="2" fill="#fff" opacity=".92"/><rect x="12" y="24" width="8" height="2.5" rx="1" fill="#fff" opacity=".92"/></svg>`
  )

export const ROUTER_TERMINAL_FAVICON_HREF =
  'data:image/svg+xml,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect width="32" height="32" rx="6" fill="#14532d"/><path fill="#4ade80" d="M8 10h16v2H8zm0 5h10v2H8zm0 5h14v2H8z"/></svg>`
  )

/**
 * Ajusta título e favicon da página; na desmontagem restaura (útil se a mesma rota abrir no painel principal).
 * @param {boolean} [enabled=true] — se false, não altera nada (ex.: mesma tela aberta dentro do Layout em /routers/.../management).
 */
export function usePopupWindowDocumentChrome({ title, faviconHref, enabled = true }) {
  useEffect(() => {
    if (!enabled) return undefined

    const prevTitle = document.title
    const link = document.querySelector('link[rel="icon"]')
    const prevHref = link?.getAttribute('href') ?? null
    const prevType = link?.getAttribute('type') ?? null

    document.title = title || prevTitle

    if (link && faviconHref) {
      link.type = faviconHref.startsWith('data:') && faviconHref.includes('svg') ? 'image/svg+xml' : 'image/png'
      link.href = faviconHref
    }

    return () => {
      document.title = prevTitle
      if (link && prevHref != null) {
        link.href = prevHref
        if (prevType) link.type = prevType
        else link.removeAttribute('type')
      }
    }
  }, [title, faviconHref, enabled])
}
